import React from "react";

import { Code } from "@packages/ds";

/**
 * Code Block component for displaying code snippets
 * @deprecated Import from @packages/ds directly using Code.Block
 */
const Block = (props: Parameters<typeof Code.Block>[0]) => {
  return <Code.Block {...props} />;
};

// Re-export Heading and Toolbar for compatibility
export const Heading = Code.Heading;
export const Toolbar = Code.Toolbar;

export default Block;
